import { MigratableJson } from '../MigratableJson';
import { TEXT_NODE_NAME } from '@builder4/shared/utils/constants';

/**
 * Migration v7: Adds maxWidthUnit property to Text components for backward compatibility
 *
 * This migration:
 * 1. Finds all Text nodes in the JSON
 * 2. Sets maxWidthUnit to '%' for existing nodes (legacy percentage behavior)
 * 3. Only sets if maxWidth exists and maxWidthUnit is not already set
 * 4. Handles breakpoint-specific maxWidth (tablet and mobile)
 */
export default function toV7<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    // Only migrate Text nodes
    if (node.displayName !== TEXT_NODE_NAME) {
      continue;
    }

    const props = { ...(node.props || {}) };

    // Set maxWidthUnit to '%' for existing nodes (legacy percentage behavior)
    // Only set if maxWidth exists and maxWidthUnit is not already set
    if (props.maxWidth !== undefined && props.maxWidthUnit === undefined) {
      props.maxWidthUnit = '%';
    }

    const tablet = props.tablet as Record<string, unknown>;
    // Handle breakpoint-specific maxWidth
    if (tablet && tablet.maxWidth !== undefined && tablet.maxWidthUnit === undefined) {
      tablet.maxWidthUnit = '%';
    }

    const mobile = props.mobile as Record<string, unknown>;
    if (mobile && mobile.maxWidth !== undefined && mobile.maxWidthUnit === undefined) {
      mobile.maxWidthUnit = '%';
    }

    // Update node with migrated data
    node.props = props;
  }

  return data;
}
